import { useEffect } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import {
  changeConfigurationActiveComponent,
  changeHelpActiveComponent,
} from "../../configurationSlice";
import { changeCurrentProduct } from "../../../common/commonSlice";

export const MagicFormsHelp = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(changeConfigurationActiveComponent("Help"));
    dispatch(changeHelpActiveComponent("Documentacion MagicForms"));
    dispatch(changeCurrentProduct("Ayuda y Documentacion"));
  }, []);
  return (
    <div
      style={{
        overflow: "auto",
        color: "white",
        padding: "2% 2%",
        width: "100%",
        height: "100%",
      }}
    >
      <h2
        style={{
          fontWeight: "bold",
          fontSize: "52px",
        }}
      >
        Magic Forms
      </h2>
      <p>
        El servicio de MagicForms de anteia es una herramienta de formularios
        inteligente, que utiliza la información de los usuarios para llenar
        formularios de manera automática. Además de generar reportes y
        reutilizar información.
      </p>
      <p>
        Esta herramienta se encarga de capturar información solicitada al
        usuario para ser usada en diferentes procesos de vinculación.
      </p>
      <p>
        El siguiente manual le dará una descripción de cada una de las secciones
        del servicio dentro del backoffice. Esto le ayudará a entender como
        realizar la navegación, interpretar los datos y descargar y visualizar
        documentos.
      </p>
      <object
        data="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20BACKOFFICE%20-%20MAGIC%20FORMS.pdf"
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <p>
          Descarga alternativa:{" "}
          <a href="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20BACKOFFICE%20-%20MAGIC%20FORMS.pdf">
            Si no se ve puede dar click aquí para descargar el PDF
          </a>
        </p>
      </object>
      <h2
        style={{
          fontWeight: "bold",
          fontSize: "36px",
        }}
      >
        Documentación de API
      </h2>
      <p>
        Además de manejo de la plataforma también ofrecemos documentación del
        API de MagicForms, la cual puede consultar en el siguiente enlace:
      </p>
      <a
        href="https://anteia.stoplight.io/docs/clients-api/10ff2526c6d7a-magic-forms-api"
        target="blank
      "
      >
        Documentación API
      </a>
    </div>
  );
};
